import { useState, useCallback, useRef } from "react";

export const useLotManagement = (activeTab, formData, setFormData) => {
  const [Lot, setLot] = useState(false);
  const [lotDrawerOpen, setLotDrawerOpen] = useState(false);
  const sizeRowRefs = useRef({});
  const [lotSizes, setLotSizes] = useState([
    {
      size: "",
      set: "",
      grossWt: "",
      netWt: "",
      price: "",
      avgGrossWt: "",
      avgNetWt: "",
      avgSpecWt: "",
    },
  ]);
  const [drawerLotSizes, setDrawerLotSizes] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});

  const setSizeRowRef = (index, element) => {
    if (element) {
      sizeRowRefs.current[index] = element;
    }
  };

  const toggleHandleLot = () => {
    setLot((prev) => {
      const newVal = !prev;
      if (!newVal && lotSizes.length > 1) {
        setLotSizes(lotSizes.slice(0, 1));
      }
      setFormData((prevForm) => ({ ...prevForm, lot: newVal }));
      return newVal;
    });
  };

  const calculateSizeAverages = () => {
    const sizeGroups = {};
    lotSizes.forEach((item) => {
      if (item.size) {
        if (!sizeGroups[item.size]) {
          sizeGroups[item.size] = {
            count: 0,
            totalNetWt: 0,
            sets: 0,
            totalGrossWt: 0,
            totalPrice: 0,
          };
        }
        sizeGroups[item.size].count += 1;
        if (activeTab === "order") {
          sizeGroups[item.size].totalNetWt += parseFloat(item.avgNetWt) || 0;
          sizeGroups[item.size].sets = 0;
          sizeGroups[item.size].totalGrossWt +=
            parseFloat(item.avgGrossWt) || 0;
        } else {
          sizeGroups[item.size].totalNetWt += parseFloat(item.netWt) || 0;
          sizeGroups[item.size].sets += parseFloat(item.set) || 0;
          sizeGroups[item.size].totalGrossWt += parseFloat(item.grossWt) || 0;
          sizeGroups[item.size].totalPrice += parseFloat(item.price) || 0;
        }
      }
    });
    return Object.keys(sizeGroups).map((size) => ({
      size,
      count: sizeGroups[size].count,
      averageNetWt: sizeGroups[size].totalNetWt / sizeGroups[size].count,
      totalSets: sizeGroups[size].sets,
      averageGrossWt: sizeGroups[size].totalGrossWt / sizeGroups[size].count,
      averagePrice: sizeGroups[size].totalPrice / sizeGroups[size].count,
    }));
  };

  const calculateTotals = (sizes) => {
    const totals = {
      totalSets: 0,
      totalGrossWt: 0,
      totalNetWt: 0,
      totalPrice: 0,
    };
    const lotData = sizes || lotSizes;
    lotData.forEach((item) => {
      const set = parseFloat(item.set) || 0;
      const price = parseFloat(item.price) || 0;
      if (activeTab === "order") {
        totals.totalSets = 0;
        totals.totalGrossWt += parseFloat(item.avgGrossWt);
        totals.totalNetWt += parseFloat(item.avgNetWt);
        totals.totalPrice += price;
      } else {
        totals.totalSets += set;
        totals.totalGrossWt += parseFloat(item.grossWt) || 0;
        totals.totalNetWt += parseFloat(item.netWt) || 0;
        totals.totalPrice += price;
      }
    });
    return totals;
  };

  const calculateItemAverages = useCallback(
    (item) => {
      const set = parseFloat(item.set) || 0;
      if (set !== 0 && activeTab === "READY") {
        return {
          avgGrossWt: item.avgGrossWt,
          avgNetWt: item.avgNetWt,
          avgSpecWt: item.avgSpecWt,
        };
      }
      if (activeTab === "order") {
        return {
          avgGrossWt: item.avgGrossWt || "0.000",
          avgNetWt: item.avgNetWt || "0.000",
          avgSpecWt: item.avgSpecWt || "0.000",
        };
      }
      const grossWt = parseFloat(item.grossWt) || 0;
      const netWt = parseFloat(item.netWt) || 0;
      const safeSet = set;
      return {
        avgGrossWt: (grossWt / safeSet).toFixed(3),
        avgNetWt: (netWt / safeSet).toFixed(3),
        avgSpecWt: ((grossWt - netWt) / safeSet).toFixed(3),
      };
    },
    [activeTab],
  );

  const updateLotSizesWithAverages = (sizes) => {
    return sizes.map((item) => {
      const averages = calculateItemAverages(item);
      return {
        ...item,
        avgGrossWt: averages.avgGrossWt,
        avgNetWt: averages.avgNetWt,
        avgSpecWt: averages.avgSpecWt,
      };
    });
  };

  const openLotDrawer = () => {
    setLotDrawerOpen(true);
    setDrawerLotSizes(
      lotSizes.length > 0
        ? [...lotSizes]
        : [
            {
              size: "",
              set: "",
              grossWt: "",
              netWt: "",
              price: "",
              avgGrossWt: "",
              avgNetWt: "",
              avgSpecWt: "",
            },
          ],
    );
  };

  const closeLotDrawer = () => {
    setLotDrawerOpen(false);
    setDrawerLotSizes([]);
  };

  return {
    Lot,
    setLot,
    lotDrawerOpen,
    setLotDrawerOpen,
    lotSizes,
    setLotSizes,
    drawerLotSizes,
    setDrawerLotSizes,
    fieldErrors,
    setFieldErrors,
    sizeRowRefs,
    setSizeRowRef,
    toggleHandleLot,
    calculateSizeAverages,
    calculateTotals,
    calculateItemAverages,
    updateLotSizesWithAverages,
    openLotDrawer,
    closeLotDrawer,
  };
};
